// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cr-periods h5 button {
  width: 100%;
  text-align: left;
  font-size: 1.44rem;
  text-transform: uppercase;
}
.cr-periods .btn-outline-primary:hover {
  color: #007bff;
  background-color: transparent;
}
.cr-periods .card-header button.btn:focus {
  box-shadow: none;
}
.cr-periods .mx-datepicker input {
  cursor: pointer;
}
.mx-datepicker-main.mx-datepicker-popup {
  z-index: 1030 !important;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
